import { render, staticRenderFns } from "./AllClients.vue?vue&type=template&id=8636eec6&scoped=true"
import script from "./AllClients.vue?vue&type=script&lang=ts"
export * from "./AllClients.vue?vue&type=script&lang=ts"
import style0 from "./AllClients.vue?vue&type=style&index=0&id=8636eec6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8636eec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8636eec6')) {
      api.createRecord('8636eec6', component.options)
    } else {
      api.reload('8636eec6', component.options)
    }
    module.hot.accept("./AllClients.vue?vue&type=template&id=8636eec6&scoped=true", function () {
      api.rerender('8636eec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/AllClients.vue"
export default component.exports